import { Link } from "react-router-dom";
import {
  setGuideMode,
  setOpenModel,
  setOpenModelMon,
  setOpenVideo,
} from "../../GuideButtons/logic/GuideLogic";
import { useEffect, useState } from "react";

import "../styles/switchebutton.css";
import { useTranslation } from "react-i18next";

export interface ISwitcherButtom {
  linkName: string;
}

export const SwitcherButtom = ({ linkName }: ISwitcherButtom) => {
  const { t } = useTranslation();
  const [switcher, setSwitcher] = useState<boolean>(false);
  useEffect(() => {
    setGuideMode(false);
    setTimeout(() => {
      setSwitcher(true);
    }, 5000);
  }, []);
  return (
    <div className="main_switcher-block">
      <Link to={linkName} style={{ textDecoration: "none" }}>
        <div
          className={switcher ? "main_switcher" : "main_switcher__OFF short"}
          onClick={() => {
            setGuideMode(true);
            setOpenVideo(false);
            setOpenModelMon(true);
            setOpenModel(false);
          }}
        >
          {switcher ? `${t("SwitcherButtom")}` : ""}
          <div
            className={
              switcher
                ? "main_switcher_circle"
                : "main_switcher_circle__OFF main_switcher_circle"
            }
          >
            ?
          </div>
        </div>
      </Link>
    </div>
  );
};
